/* eslint-disable no-nested-ternary */
import { LoadingIndicator, Button, Icons } from '@components';
import { DependentesService } from '@services';
import { format, parse } from 'date-fns';
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { getRequerimentosForms } from '../../../../store/requerimentos/thunks';
import { Dependente } from './Dependente';

const REFERENCIA_DEPENDENTES = 'DeclaracaoDependentesDiretosAssistido';

export const Dependentes = () => {
  const [loading, setLoading] = useState(true);
  const [dependentes, setDependentes] = useState([]);
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { allForms: formularios, allFormsRequestDone } = useSelector(
    (state) => state.requerimentos
  );

  const formularioDependentes = useMemo(
    () => formularios.find((f) => f.referencia === REFERENCIA_DEPENDENTES),
    [formularios]
  );

  const isDependentesHabilitado = formularioDependentes?.habilitado ?? false;

  useEffect(() => {
    if (!allFormsRequestDone) {
      dispatch(getRequerimentosForms());
    }
  }, [allFormsRequestDone, dispatch]);

  const getDependentes = useCallback(() => {
    const matricula = user.data?.matricula;
    const token = user.data?.token;

    if (!matricula || !token) {
      setLoading(false);
      return;
    }

    const service = new DependentesService();
    service
      .getDependentesIRRF(matricula, token)
      .then((data) => {
        setLoading(false);
        setDependentes(() =>
          data.map((dependente) => ({
            ...dependente,
            dataNascimento: Number(dependente.dataNascimento)
              ? format(
                  parse(dependente.dataNascimento, 'yyyyMMdd', new Date()),
                  'dd/MM/yyyy'
                )
              : '',
          }))
        );
      })
      .catch(() => {
        toast.error('Erro ao recuperar os dados');
        setLoading(false);
      });
  }, [user.data.matricula, user.data.token]);

  useEffect(() => {
    getDependentes();
  }, [getDependentes]);

  const handleIrParaRequerimento = () => {
    if (isDependentesHabilitado && formularioDependentes) {
      navigate(`/requerimentos/novo/${formularioDependentes.destino}`);
    }
  };

  return (
    <div>
      {!loading && dependentes.length > 0 ? (
        dependentes.map((d, i) => (
          <Fragment key={d.cpf}>
            <Dependente dependente={d} index={i} />
            {dependentes.length - 1 !== i && <hr className="my-4" />}
          </Fragment>
        ))
      ) : !loading && dependentes.length === 0 ? (
        <Fragment key={0}>
          <div className="card mb-32">
            <div className="card-body fw-bold">
              Você não possui dependentes de IRRF
            </div>
          </div>
        </Fragment>
      ) : (
        <LoadingIndicator />
      )}
      <hr className="my-4" />
      <div
        className="card shadow-sm border-0 p-4"
        style={{ borderRadius: '12px' }}
      >
        <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
          <div>
            <h3 className="fw-bold mb-2">
              Declaração de Dependentes Diretos para Assistido
            </h3>
            <p className="mb-0 text-muted">
              Para alterar os dependentes, favor preencher o requerimento
              Declaração de Dependentes Diretos para Assistido, clicando no
              botão ao lado.
            </p>
          </div>
          <div className="d-flex flex-column align-items-center flex-shrink-0">
            <Button
              transparent
              color="orange"
              onClick={handleIrParaRequerimento}
              disabled={loading || !isDependentesHabilitado}
            >
              Ir para Requerimento
            </Button>
            {!isDependentesHabilitado && allFormsRequestDone && (
              <div
                className="d-flex align-items-start gap-2 mt-2 p-2"
                style={{
                  backgroundColor: '#fff3e0',
                  borderRadius: '8px',
                  maxWidth: '280px',
                }}
              >
                <Icons
                  path="warning"
                  size={1.2}
                  style={{ color: '#f9a825', flexShrink: 0 }}
                />
                <span className="ts-12 fw-bold" style={{ color: '#f9a825' }}>
                  Para criar um novo requerimento desse tipo é necessário
                  cancelar o requerimento anterior em andamento.
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
